export default {
  path: '/monitor',
  component: () => import('../components/Index'),
  children: [
    {
      path: "/",
      redirect: "index",
    },
    {
      path: "index",
      component: () => import('../components/monitor/Index'),
    },
  ]
}


// WEBPACK FOOTER //
// ./src/pages/pc/router/monitor.js